/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectOwnerResponseAdminAdminDto } from '../../models/project-owner-response-admin-admin-dto';

export interface AdminProjectOwnersControllerUnbanProjectOwner$Params {
  id: string;
}

export function adminProjectOwnersControllerUnbanProjectOwner(http: HttpClient, rootUrl: string, params: AdminProjectOwnersControllerUnbanProjectOwner$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectOwnerResponseAdminAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminProjectOwnersControllerUnbanProjectOwner.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectOwnerResponseAdminAdminDto>;
    })
  );
}

adminProjectOwnersControllerUnbanProjectOwner.PATH = '/admin/project-owners/{id}/unban';
